import React, { Component } from "react";
import { Button } from "antd";
import BreadCrumb from "../../../components/BreadCrumb";
import * as Style from "./styles/Disability-Listing";
import { Link, useHistory } from "react-router-dom";
import addIcon1 from "../../../assets/images/DeathModuleNew/addIcon.png";

class Disability extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div style={{ position: "relative" }}>
        <Style.Main>
          <Style.Cards
            style={{
              borderBottom: "1px solid #F0F0F0",
            }}
          >
            <Style.SubCards
              style={{
                display: "flex",
                justifyContent: "space-between",
                width: "100%",
              }}
            >
              <Style.CardsHead>
                <h3
                  style={{
                    fontWeight: "bold",
                    fontFamily: "Poppins",
                    fontSize: "20px",
                  }}
                >
                  Disability
                </h3>
              </Style.CardsHead>
              <Style.PropertyAdd
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                }}
              >
                <div style={{ marginRight: "1rem" }}>
                  <h3 style={{ fontFamily: "Poppins", fontSize: "20px" }}>Add Disability</h3>
                </div>
                <Link
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                  to={`/protector/disability`}
                >
                  <div className="upload" style={{ width: "28px", height: "28px" }}>
                    <img
                      src={addIcon1}
                      width={12}
                      height={12}
                      style={{ width: "16px", height: "16px" }}
                      alt="addicon"
                    ></img>
                  </div>
                </Link>
              </Style.PropertyAdd>
            </Style.SubCards>
          </Style.Cards>
        </Style.Main>
      </div>
    );
  }
}

export default Disability;
